import * as ACTION_TYPES from '../actions/actionTypes';

const defaultState = null;

function errorMessageReducer(state = defaultState, action) {
  const { type, error } = action;
  if (type === ACTION_TYPES.RESET_ERROR_MESSAGE) {
    return null;
  } else if (error) {
    return error;
  };
  return state;
};

export default errorMessageReducer;